import React from 'react';
import { Button, Card, Space, Tag, Typography } from 'antd';
import { CheckCircleOutlined, RobotOutlined, SmileOutlined } from '@ant-design/icons';

const { Paragraph, Title, Text } = Typography;

export default function OnboardingWelcomeCard({ welcomeSeen, oscarEnabled, onMarkSeen, onOpenOscar, canManageEmployee }) {
    return (
        <Card className="onboarding-panel onboarding-welcome-panel">
            <Space direction="vertical" size={14} style={{ width: '100%' }}>
                <Space>
                    <Tag color={welcomeSeen ? 'success' : 'processing'}>
                        {welcomeSeen ? 'Welcome completed' : 'Welcome in progress'}
                    </Tag>
                    <Tag color={oscarEnabled ? 'purple' : 'default'}>
                        {oscarEnabled ? 'Oscar enabled' : 'Oscar disabled'}
                    </Tag>
                </Space>
                <Title level={4} style={{ margin: 0 }}>Meet Oscar and clear the first-day friction</Title>
                <Paragraph style={{ marginBottom: 0 }}>
                    Give starters one place to understand the workflow, ask questions, and see what still blocks approval.
                </Paragraph>
                <Space wrap>
                    <Button type="primary" icon={<RobotOutlined />} onClick={onOpenOscar}>
                        Open Oscar
                    </Button>
                    {!welcomeSeen && canManageEmployee ? (
                        <Button icon={<CheckCircleOutlined />} onClick={onMarkSeen}>
                            Mark welcome seen
                        </Button>
                    ) : null}
                </Space>
                {!welcomeSeen ? (
                    <Text type="secondary"><SmileOutlined /> Show this block first for new starters so the onboarding page does not feel like a back-office form.</Text>
                ) : null}
            </Space>
        </Card>
    );
}
